import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ItemModel } from '../../../shared/models/payment/order/item.model';
import { ThumbSourceFactoryService } from '../../../shared/services/thumb-source-factory.service';

@Component({
    selector: 'completed-order-items',
    templateUrl: './completed.order.items.component.html',
    styleUrls: ['../../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedOrderItemsComponent {
    @Input('items') items: Array<ItemModel>;

    constructor(
        protected thumbFactory: ThumbSourceFactoryService
    ) {}

    /**
     * Check Component Tag
     * @param item
     */
    public hasTagComponente(item: any): boolean {
        if (!item || !item.item || typeof item.item.tags !== 'object') {
            return false;
        }

        for (const key in item.item.tags) {
            if (item.item.tags[key].slug === 'componente') {
                return true;
            }
        }

        return false;
    }

    /**
     * Check if has extra fields from order item
     **/
    public hasAttributesExtraFields(item) {
        return item.extra_fields.length > 0;
    }
    /**
     * Check if has extra fields from order item's item
     **/
    public hasExtraFields(item) {
        return Object.keys(item.item.extra_fields).length > 0;
    }
    /**
     * Generate thumb image.
     **/
    public getThumbSource(source: string) {
        return this.thumbFactory.make(source, 56, 70);
    }
    /**
     * Get url property from first array item if has or 'javscript:;' if empty.
     * @return string
     **/
    public getUrl(urls: Array<{url: string}>) {
        if (urls.length === 0) {
            return 'javascript:;';
        }

        return `/${urls[0].url}`;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/completed/order/items/completed.order.items.component.ts